var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMy = function SvgMy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21796_20946",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21796_20946)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4.59961,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 4.59961)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 0)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9.19922,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 9.19922)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13.8008,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 13.8008)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18.4004,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 18.4004)",
    fill: "#C12F33"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 11.5,
    fill: "#0F0F84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29392 9.01867C1.60358 9.01867 0.233285 7.64861 0.233285 5.95855C0.233285 4.2685 1.60358 2.89844 3.29392 2.89844C3.89614 2.89844 4.45773 3.07234 4.93121 3.37266C4.67773 3.29296 4.40798 3.25 4.1282 3.25C2.65119 3.25 1.45383 4.44735 1.45383 5.92436C1.45383 7.40137 2.65119 8.59872 4.1282 8.59872C4.485 8.59872 4.82549 8.52885 5.13672 8.40203C4.62409 8.78912 3.98582 9.01867 3.29392 9.01867Z",
    fill: "#EFC744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36405 4.10644L6.92256 5.24768L7.05675 3.9844L7.19123 5.24771L7.74947 4.1066L7.44371 5.33962L8.35867 4.45832L7.64955 5.51232L8.81086 4.99712L7.78391 5.74498L9.05151 5.65803L7.83059 6.00953L9.05159 6.36132L7.78397 6.27408L8.8111 7.02217L7.64966 6.50671L8.35903 7.56087L7.44387 6.67936L7.74991 7.91245L7.19141 6.77121L7.05722 8.03449L6.92273 6.77118L6.3645 7.91229L6.67025 6.67927L5.7553 7.56057L6.46442 6.50657L5.3031 7.02176L6.33006 6.27391L5.06245 6.36086L6.28337 6.00935L5.06237 5.65757L6.32999 5.74481L5.30287 4.99672L6.4643 5.51218L5.75494 4.45802L6.6701 5.33953L6.36405 4.10644Z",
    fill: "#EFC744"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/my.2d369aa92788de7615e0337d0ff43ff1.svg";